<style scoped>
    /*容器*/
    .login-container {
        width: 100%;
        height: 100%;
        /*background: linear-gradient(to right, #343b53, #2f485c);*/
	    /*2020-6-17 MODIFY BY DUAN MCF风格式样修改*/
        /*background: linear-gradient(to right, #092a9c, #0c5692);*/
		background: linear-gradient(to right, deepskyblue, #0c5692);
        overflow: hidden;
    }
    .flex-div {
        display: flex;
    }
    /*中部*/
    .login-container-box {
        width: 1000px;
        height: 400px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
    .left-logo-div {
        color: #fff;
        font-size: 36px;
        width: 500px;
        text-align: center;
        /*padding-top: 120px;*/
    }
    .left-title-div {
        font-size: 28px;
        color: #f2f2f2;
        text-align: center;
        margin-top: 20px;
    }
    .left-right-line {
        width: 2px;
        height: 300px;
        background-color: #3e516c;
        float: right;
        margin-top: -250px;
    }
    .login-container-box-right {
        width: 500px;
        padding: 32px 60px;
    }
    .right-login-tip {
        font-size: 18px;
        color: #fff;
        margin-top: 20px;
    }
    input.login-input {
        display: block;
        width: 100%;
        margin: 36px 0;
        line-height: 46px;
        background: linear-gradient(to right, #314157, #304459);
        border: 0;
        border-bottom: 1px solid #3e516c;
        color: #FFFFFF;
        font-size: 16px;
    }
    input {
        outline: 0;
    }
    .login-btn {
        width: 60%;
        height: 50px;
        border-radius: 40px;
        border: 0;
        background-color: #50e399;
        color: #757575;
        font-size: 16px;
        letter-spacing: 6px;
    }
	.pwd-btn {
		width: 30%;
		height: 50px;
		border-radius: 40px;
		border: 0;
		background-color: #50e399;
		color: #757575;
		font-size: 16px;
		letter-spacing: 6px;
	}
    .corp-dt-div {
        position: absolute;
        bottom: 0;
        text-align: center;
        width: 100%;
    }
    .corp-title-div {
        font-size: 26px;
        /*color: #3e516c;*/
		/*color:#071f42;*/
		color: white;
        font-weight: 600;
        letter-spacing: 2px;
    }
    .copywrite-div-login {
        font-size: 16px;
        line-height: 40px;
        /*color: #586475;*/
		color: white;
    }
    .msg-error {
        position: absolute;
        right: -130px;
        top: 16px;
        color: #e05f5f;
        font-size: 14px;
        display: block;
        width: 120px;
        text-align: left;
    }
    .relative-div{
        position: relative;
    }
</style>

<template>
    <div class="login-container">
        <div class="login-container-box flex-div">
            <div class="login-container-box-left">
				<!--2020-9-2 NO.74 MODIFY BY DUAN-->
                <!--<div class="left-logo-div">刑天</div>-->
				<div style="margin-left: 196px"><img src="../img/footer_logo_fcc.svg" height="109" width="107"/></div>
				<div class="left-logo-div">佛山富士离合器有限公司</div>
				<div class="left-title-div">China FCC Foshan Co.,Ltd</div>
				<div class="left-title-div">采购EDI系统</div>
				<div class="left-title-div">Purchasing EDI System</div>
				<div class="left-right-line"></div>
            </div>
            <div class="login-container-box-right" @keyup.enter="handleSubmit">
                <div class="right-login-tip">登录 Login</div>
                <div class="right-login-form">
                    <div class="relative-div">
                        <input type="text" class="login-input username-input" v-model="formInfo.userAcc" placeholder="账号" />
                        <span class="msg-error" v-show="showNameError"><i class="el-icon-warning"></i>&nbsp;{{nameMsg}}</span></div>
                    <div class="relative-div">
                        <input type="password" class="login-input pwd-input" v-model="formInfo.userPassword" placeholder="密码" />
                        <span class="msg-error" v-show="showPwdError"><i class="el-icon-warning"></i>&nbsp;{{pwdMsg}}</span></div>
					&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <input type="button" class="login-btn submit-btn" style="color: black;font-family:黑体 " value="登录" @click="handleSubmit" />
					<!--<input type="button" class="pwd-btn submit-btn" value="修改密码" @click="changePwd()" />-->
                </div>
            </div>
        </div>

        <div class="corp-dt-div">
            <!--<div class="corp-title-div">-->
                <!--毕恩吉商务信息系统工程（上海）有限公司-->
            <!--</div>-->
            <div class="copywrite-div-login">
				Copyright @ China FCC Foshan Co.,Ltd   All rights reserved.
            </div>
			<div class="copywrite-div-login">
				<a href="https://beian.miit.gov.cn" target="_blank"><span style="color: white">粤ICP备2021106821号</span></a>
			</div>
        </div>
		<el-dialog title="密码重置" :visible.sync="dialogVisible" width="600px" :close-on-click-modal="false">
			<div class="dialog-overflow iot-form">
				<Form ref="pwdFrom" :model="pwdInfo" :rules="ruleValidate">
					<FormItem label="用户名" prop="userAcc">
						<Input v-model="pwdInfo.userAcc" type="text"></Input>
					</FormItem>
					<FormItem label="原密码" prop="oldPassword">
						<Input v-model="pwdInfo.oldPassword" type="password"></Input>
					</FormItem>
					<FormItem label="新密码" prop="userPassword">
						<Input v-model="pwdInfo.userPassword" type="password"></Input>
					</FormItem>
					<FormItem label="确认密码" prop="userPasswordCp">
						<Input v-model="pwdInfo.userPasswordCp" type="password"></Input>
					</FormItem>
					<FormItem class="iot-form-actions-div check-child-submit">
						<Button type="primary" class="iot-btn-submit info-color"
								v-loading.fullscreen.lock="fullscreenLoading" @click="submitPwdReset('pwdFrom')"><i
							class="fa fa-save"></i>&nbsp;&nbsp;提交
						</Button>
						<Button type="ghost" class="iot-btn-cancel mgn-lf-10" @click="cancelPwdReset"><i
							class="fa fa-close"></i>&nbsp;&nbsp;取消
						</Button>
					</FormItem>
				</Form>
			</div>
		</el-dialog>
    </div>
</template>



<script>
import axios from 'axios';
    export default {
        data() {
			var validatePass = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('请再次输入密码'));
				} else if (value !== this.pwdInfo.userPassword) {
					callback(new Error('两次输入密码不一致!'));
				} else {
					callback();
				}
			};
            return {
                formInfo: {},
                rules: {
                    userAcc: [{
                        required: true,
                        message: '请输入账号',
                        trigger: 'blur'
                    }],
                    userPassword: [{
                        required: true,
                        message: '请输入密码',
                        trigger: 'blur'
                    }],
                },
                showNameError: false,
                showPwdError: false,
                nameMsg: '',
                pwdMsg: '',
				queryParam: {
					userAcc:'',
					oldPassword:'',
					codeType: ''
				},
				fullscreenLoading: false,
				dialogVisible: false,
				syscode:{},
				pwdInfo: {},
				// queryParam: {
				// 	codeType: ''
				// },
				ruleValidate: {
					userAcc: [
						{required: true, message: '请输入账号', trigger: 'blur'}
					],
					oldPassword: [{
						required: true,
						message: '请输入原密码',
						trigger: 'blur'
					}],
					userPassword: [
						{required: true, message: '请输入密码', trigger: 'blur'}
					],
					userPasswordCp: [
						{required: true, validator: validatePass, trigger: 'blur'}
					],
				},
            }
        },
		mounted() {
			//获取密码系数规则
			this.queryParam.codeType = "PWD_CONFIG";
			this.syscode = this.$sdnJob.getCodeByType(this, this.queryParam);
			console.log(this.syscode);
		},
        methods: {
            handleSubmit() {
                var _this = this;
                if (this.$util.isEmpty(this.formInfo.userAcc)) {
                    _this.showError('name', '请输入账号');
                    return;
                }
                if (this.$util.isEmpty(this.formInfo.userPassword)) {
                    _this.showError('pwd', '请输入密码');
                    return;
                }
                _this.$httpUtil.login(_this.$api.login, JSON.stringify(_this.formInfo),
                    function(token) {
                        _this.$cookie.remove(_this.$config.cookies.token);
                        _this.$cookie.set(_this.$config.cookies.token, token);
                        _this.$httpUtil.ajaxGet(this, _this.$api.user.current, {}, function(response) {
                            _this.resetMsg();
							var currUser = response.data.data;
							//2020-9-15 NO.175 ADD BY DUAN START
							if(currUser.roleId=='3'){
								_this.$util.error("该用户没有权限！");
								return;
							}
							//2020-9-15 NO.175 ADD BY DUAN END
                            _this.$util.success('登录成功！');
                            _this.$cookie.remove(_this.$config.cookies.currRoleId);
                            _this.$cookie.set(_this.$config.cookies.currRoleId, currUser.roleId);
                            _this.$cookie.remove(_this.$config.cookies.currPlantId);
                            _this.$cookie.set(_this.$config.cookies.currPlantId, currUser.plantNo);
                            _this.$cookie.remove(_this.$config.cookies.currUser);
                            _this.$cookie.set(_this.$config.cookies.currUser, JSON.stringify(currUser));
                            // _this.$store.commit('updateMenulist');
                            _this.loginFlag = true;
                            //登录成功，获取token
                            _this.$router.push({
                                name: _this.$config.mainPage,
                            })
                        });
                    },
                    function(msg) {
                        if (msg.indexOf('密码') >= 0) {
                            _this.showError('pwd', msg);
                        } else {
                            _this.showError('name', msg);
                        }
                    })
            },
            changePwd(){
            	// alert(this.syscode.length);
            	if(this.syscode.length === 0){
					this.$util.warning("请先登录系统。");
				}else{
					this.dialogVisible = true;
				}

				// var _this = this;
				// _this.queryParam.userAcc = this.formInfo.userAcc;
				// alert(_this.queryParam.userAcc);
				// _this.$router.push({
				// 	name: _this.$config.changePwd,
				// })
				// _this.$httpUtil.ajaxGet(this, _this.$api.changepassword, _this.queryParam, function(response) {
				// 	})
			},
			// 提交密码重置
			submitPwdReset(formName) {
				var _this = this;
				_this.fullscreenLoading = true;
				//Alpha
				let flgAlpha = false;
				//Number
				let flgNumber = false;
				//BigChat
				let flgBigChat = false;
				//Length
				var len = 6;
				//Special
				let flgSpecial = false;
				this.syscode.forEach(item => {
					if (item.code == "PWD_ALPHA" && item.codeNm == "TRUE") flgAlpha = true;
					if (item.code == "PWD_NUMBER" && item.codeNm == "TRUE") flgNumber = true;
					if (item.code == "PWD_BIG" && item.codeNm == "TRUE") flgBigChat = true;
					if (item.code == "PWD_SPECIAL" && item.codeNm == "TRUE") flgSpecial = true;
					if (item.code == "PWD_LENGTH") len = parseInt(item.codeNm);
				})
				var password = _this.pwdInfo.userPassword;
				var password2 = _this.pwdInfo.userPasswordCp;
				var type1 = /(?=.*?[A-Z])/;//至少1个大写字母
				var type2 = /(?=.*?[0-9])/;//至少1个数字
				var type3 = /(?=.*?[a-z])/;//至少1个小写字母
				var type4 = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[^\w\s]).{len,}$/; //特殊
				if (password == '' || password == null || password == undefined) {
					_this.$util.error("密码不能为空!");
					_this.fullscreenLoading = false;
					return;
				}
				if(password.length < len){
					_this.$util.error("密码长度至少需要"+len+"位。");
					_this.fullscreenLoading = false;
					return;
				}
				if (flgSpecial) {
					//复合特殊
					if (!type4.test(password)) {
						_this.$util.error("复合密码需要有大小写字母数字和特殊符号!");
						_this.fullscreenLoading = false;
						return;
					}
				}
				if(flgNumber){
					if (!type2.test(password)) {
						_this.$util.error("密码需要有1个数字!");
						_this.fullscreenLoading = false;
						return;
					}
				}
				if(flgBigChat){
					if (!type1.test(password)) {
						_this.$util.error("密码需要有1个大写字母!");
						_this.fullscreenLoading = false;
						return;
					}
				}
				if(flgAlpha){
					if (!type3.test(password)) {
						_this.$util.error("密码需要有1个小写字母!");
						_this.fullscreenLoading = false;
						return;
					}
				}
				if (!(password == password2)) {
					_this.$util.error("两次输入密码不一致!");
					_this.fullscreenLoading = false;
					return;
				}
				this.$refs[formName].validate((valid) => {
					if (valid) {
						var currUser = JSON.parse(_this.$cookie.get(_this.$config.cookies.currUser));
						currUser.userAcc =_this.pwdInfo.userAcc;
						currUser.oldPassword = _this.pwdInfo.oldPassword;
						currUser.userPassword = _this.pwdInfo.userPassword;
						_this.$httpUtil.ajaxPatch(_this, _this.$api.user.list, currUser, function (res) {
							alert(res.data.status);
							if (res.data.status==200) {
								_this.$util.success('修改成功');
								_this.dialogVisible = false;
								_this.fullscreenLoading = false;
							} else {
								_this.$util.error("用户不存在");
								_this.dialogVisible = false;
								_this.fullscreenLoading = false;
								// _this.$util.error(res.data.data.message);
							}
						});
					}
				});
			},
			// 取消
			cancelPwdReset() {
				this.pwdInfo = {};
				this.dialogVisible = false;
			},
			resetMsg(){
                this.showNameError = false;
                this.showPwdError = false;
                this.nameMsg = '';
                this.pwdMsg = '';
            },
            showError(type, msg) {
                this.resetMsg();
                if (type === 'name') {
                    this.showNameError = true;
                    this.nameMsg = msg;
                } else {
                    this.showPwdError = true;
                    this.pwdMsg = msg;
                }
            },
        }
    }
</script>





// WEBPACK FOOTER //
// src/views/Login.vue